import type { ActiveBacklogViewType } from "@/shared/types";

export const ACTIVE_BACKLOG_VIEW_EXTRACT = "extract" as const;

export const backlogFocusOptions: Record<ActiveBacklogViewType, string> =
  Object.freeze({
    [ACTIVE_BACKLOG_VIEW_EXTRACT]: "Extract",
  });
